import { useState } from "react";
import { FileText, ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { fileUrl, formatErr, uploadFile } from "@/lib/api";

export default function FileUploader({ value, onChange, kind, accept, label, testid, image }) {
  const [busy, setBusy] = useState(false);
  const add = async (files) => {
    if (!files?.length) return;
    setBusy(true);
    const out = [...value];
    for (const f of Array.from(files)) {
      try {
        const r = await uploadFile(f, kind);
        out.push({ path: r.path, name: r.name, content_type: r.content_type });
      } catch (e) {
        toast.error(`${f.name}: ${formatErr(e)}`);
      }
    }
    onChange(out);
    setBusy(false);
  };
  return (
    <div className="space-y-3" data-testid={testid}>
      <div className="flex flex-wrap gap-3">
        {value.map((f, i) => (
          <div key={f.path} className="relative">
            {image ? (
              <img src={fileUrl(f.path)} alt="" className="h-24 w-24 rounded-lg border object-cover" />
            ) : (
              <a href={fileUrl(f.path)} target="_blank" rel="noreferrer" className="flex h-24 w-36 flex-col items-center justify-center gap-1 rounded-lg border bg-secondary/50 p-2 text-center text-xs">
                <FileText className="h-6 w-6 text-primary" /><span className="line-clamp-2 break-all">{f.name}</span>
              </a>
            )}
            <button type="button" data-testid={`${testid}-remove-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))} className="absolute -right-2 -top-2 rounded-full bg-destructive p-1 text-white shadow">
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
        <label className="flex h-24 w-24 cursor-pointer flex-col items-center justify-center gap-1 rounded-lg border-2 border-dashed text-xs text-muted-foreground hover:border-primary/50">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <ImagePlus className="h-5 w-5" />}
          {label}
          <input type="file" multiple accept={accept} className="hidden" data-testid={`${testid}-input`} disabled={busy} onChange={(e) => { add(e.target.files); e.target.value = ""; }} />
        </label>
      </div>
    </div>
  );
}
